/**
 * ? HOW LUMINANCE WORKS:
 * Use luminance as percentage of light to add to the current color. Example: 0.05 is adding a 5% luminance
 */
export function colorLuminance(hex: string, lum: number = 0) {
  // Validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');

  // Convert #ccc to #cccccc
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // Convert to decimal and change luminosity
  let rgb = '#',
    c,
    i;
  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + Number(c * lum)), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
}
